import { HighlightedDetailField } from "../../../components";
import { FINISHING_FILTERS } from "../../../constants";
import { useStationListWithCache } from "../../../components/StationHookFormSelect";
import { useMaterialListWithCache } from "../../../components/HubMaterialHookSelect/useMaterialListWithCache";

import { FieldGrid } from "../styles";
import { Section, SectionSubHeader } from "../components";

const PartFoundry = ({ section = {}, workOrder = {} }) => {
  const config = section?.config || {};
  const route = section?.routing?.[0];
  const { stations = [] } = useStationListWithCache();

  const { materials: cached } = useMaterialListWithCache();
  const materials = Array.isArray(cached) ? cached : cached?.materials || [];

  const station = route?.stationId
    ? stations.find((s) => s.id === route.stationId)
    : null;

  const material = workOrder?.materialId
    ? materials.find((m) => m.id === workOrder.materialId)
    : null;

  return (
    <Section icon="Zap" label="Foundry Department" spanishLabel="Fundición">
      <FieldGrid columns={2}>
        <HighlightedDetailField
          label="Station"
          spanishLabel="Estación"
          value={station?.label}
        />
        <HighlightedDetailField
          label="Material"
          spanishLabel="Material"
          value={material?.name ?? material?.label}
        />
      </FieldGrid>

      <SectionSubHeader label="Heat" spanishLabel="Calentamiento" />
      <FieldGrid columns={4}>
        <HighlightedDetailField
          label="Metal Temp"
          spanishLabel="Temp del Metal"
          value={config?.metalTemp}
          endAdornment="°F"
        />
        <HighlightedDetailField
          label="Shell Temp"
          spanishLabel="Temp de la Cáscara"
          value={config?.shellTemp}
          endAdornment="°F"
        />
        <HighlightedDetailField
          label="Pounds / Heat"
          spanishLabel="Libras / Calentamiento"
          value={config?.poundsPerHeat}
        />
        <HighlightedDetailField
          label="Trees / Heat"
          spanishLabel="Árboles / Calentamiento"
          value={config?.treesPerHeat}
        />
      </FieldGrid>

      <SectionSubHeader label="Pour Setup" spanishLabel="Configuración de Vertido" />
      <FieldGrid columns={5}>
        <HighlightedDetailField
          label="Filter"
          spanishLabel="Filtro"
          value={FINISHING_FILTERS[config?.filter - 1]}
        />
        <HighlightedDetailField
          label="Metal Weight"
          spanishLabel="Peso del Metal"
          value={config?.weight}
        />
        <HighlightedDetailField
          label="Wrap Tree"
          spanishLabel="Árbol Envuelto"
          value={config?.wrapTree}
        />
        <HighlightedDetailField
          label="Hot Top"
          spanishLabel="Parte Superior Caliente"
          value={config?.hotTop}
        />
        <HighlightedDetailField
          label="Cover"
          spanishLabel="Cubierta"
          value={config?.cover}
        />
      </FieldGrid>

      <SectionSubHeader label="Notes" spanishLabel="Notas" />
      <HighlightedDetailField
        label="Notes"
        spanishLabel="Notas"
        value={section?.notes}
      />
    </Section>
  );
};

export default PartFoundry;
